//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo, useState } from "react";
import styled from "styled-components";
//  -- Constants ----------------------
import { Button, IconButton, Modal } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { Row } from "antd";
import { get } from "lodash";
import COLOR from "utils/constants/color";

const Image = styled.img`
  width: 100%;
`;

const Text = styled.span`
  color: rgb(0 0 0 / 85%);
  font-size: 20px;
`;


const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: auto;
  outline: none;
  padding: 2px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  position: relative;
  overflow: hidden;
  
  /* Box shadow based on selection state */
  box-shadow: ${({ selected }) =>
    selected
      ? "0 0 12px 4px rgba(24, 144, 255, 0.8)" // brighter highlight for selected
      : "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)"};
  
  /* Background subtle effect on selection */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ selected }) => 
      selected ? "rgba(24, 144, 255, 0.05)" : "transparent"};
    z-index: 0;
    transition: background-color 300ms ease;
  }
  
  /* Border effect on selection */
  border: ${({ selected }) => 
    selected ? "2px solid rgba(24, 144, 255, 0.7)" : "2px solid transparent"};
  
  /* Scale effect when clicked */
  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  }
  
  /* Hover effects */
  &:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.18), 0 4px 8px rgba(0, 0, 0, 0.16);
    
    &:before {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  
  /* Ripple effect on click */
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 0;
    border-radius: 100%;
    transform: scale(1, 1) translate(-50%, -50%);
    transform-origin: 50% 50%;
  }
  
  &:focus:not(:active)::after {
    animation: ripple 0.6s ease-out;
  }
  
  @keyframes ripple {
    0% {
      transform: scale(0, 0) translate(-50%, -50%);
      opacity: 0.5;
    }
    100% {
      transform: scale(20, 20) translate(-50%, -50%);
      opacity: 0;
    }
  }
  
  /* Ensure content is above pseudo-elements */
  & > * {
    position: relative;
    z-index: 1;
  }
`;
const NewTag = styled.div`
  color: #fff;
  background-color: rgb(211, 51, 49);
  text-transform: uppercase;
  font-weight: 800;
  font-weight: 800;
  width: 60px;
  position: absolute;
  top: -22px;
`;
const ModalContent = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const TopRow = styled(Row)`
  border: 0.5px solid #3c393957;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: flex-end;
`;

const ModalRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`;

const CoversCardList = ({
  data,
  onClick,
  onDelete,
  selectionResource,
  selectedItem,
}) => {
  const [deleteToggle, setDeleteToggle] = useState(false);

  const selectedDataIds = useMemo(() => {
    return selectedItem?.map((item) => item.id) || "";
  }, [selectedItem]);

  return (
    <>
      {selectionResource ? null : (
        <TopRow>
          <IconButton
            onClick={() => setDeleteToggle(true)}
            style={{ padding: 0 }}
          >
            <Delete color="secondary" />
          </IconButton>
        </TopRow>
      )}

      <Modal open={deleteToggle} onClose={() => setDeleteToggle(false)}>
        <ModalContent>
          <Text style={{ fontWeight: "bold", color: "black" }}>
            <strong>{`Are you sure you want to delete this?`}</strong>
          </Text>
          <ModalRow>
            <Button
              style={{ marginRight: "4px" }}
              onClick={() => setDeleteToggle(false)}
            >
              Cancel
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                if (onDelete) {
                  onDelete(data.id);
                }
                setDeleteToggle(false);
              }}
            >
              Delete
            </Button>
          </ModalRow>
        </ModalContent>
      </Modal>
      <Wrapper selected={selectedDataIds?.includes(data?.id)}>
        {get(data, "new", false) ? <NewTag>New</NewTag> : null}
        <div className="card-resource-1">
          <a onClick={() => onClick(data)}>
            <div className="card-resource-overlay"></div>
            <Image
              className="card-resource-image"
              src={data.thumbnail}
              alt={data.displayName}
            />

            <div className="cstmVdoTitle">{data.displayName} </div>
          </a>
        </div>
      </Wrapper>
    </>
  );
};

export default CoversCardList;


